'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useCallback, type PropsWithChildren } from 'react';
import type { PanelTypes } from '@/components/panels/panelRegistry';
import { WorkspaceContext } from '@/contexts/workspaceContext';
import { PanelSize, type SidePanelSize, type DialogEntry, type DialogOptions, type DialogStore, type SidePanelStore } from './workspaceContextTypes';
export const WorkspaceProvider = t0 => {
  const $ = _c(17);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [dialogStack, setDialogStack] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = (id, content, options) => {
      setDialogStack(stack => [...stack, {
        isLoading: false,
        ...options,
        id,
        content
      }]);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const openDialog = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setDialogStack(_temp);
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const backDialog = t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setDialogStack([]);
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const closeAllDialogs = t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = (id_0, content_0, options_0) => {
      setDialogStack(stack_1 => [...stack_1.slice(0, -1), {
        isLoading: false,
        ...options_0,
        id: id_0,
        content: content_0
      }]);
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const replaceDialog = t5;
  let t6;
  if ($[5] !== dialogStack) {
    t6 = id_1 => {
      if (id_1) {
        return dialogStack.some(d => d.id === id_1);
      }
      return dialogStack.length > 0;
    };
    $[5] = dialogStack;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const isDialogOpen = t6;
  let t7;
  if ($[7] !== dialogStack || $[8] !== isDialogOpen) {
    t7 = {
      stack: dialogStack,
      open: openDialog,
      back: backDialog,
      closeAll: closeAllDialogs,
      replace: replaceDialog,
      isOpen: isDialogOpen
    };
    $[7] = dialogStack;
    $[8] = isDialogOpen;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const sharedDialog = t7;
  const [rightPanel, t8] = useState({
    isOpen: false,
    isAbsolute: false,
    Component: undefined,
    panelSize: PanelSize.Large,
    setSize: panelSize => setRightPanel(state => ({
      ...state,
      panelSize
    })),
    setIsOpen: (isOpen, panelSize_0, isAbsolute) => setRightPanel(state_0 => ({
      ...state_0,
      isOpen,
      isAbsolute: isAbsolute ?? false,
      panelSize: isOpen ? panelSize_0 ?? PanelSize.Large : state_0.panelSize
    })),
    setComponent: Component => setRightPanel(state_1 => ({
      ...state_1,
      Component
    }))
  });
  const setRightPanel = t8;
  const [snackbar, t9] = useState({
    isOpen: false,
    message: "",
    showMessage: message => setSnackbar(state_2 => ({
      ...state_2,
      isOpen: true,
      message,
      isError: false,
      isWarning: false
    })),
    showErrorMessage: message_0 => setSnackbar(state_3 => ({
      ...state_3,
      isOpen: true,
      message: message_0,
      isError: true,
      isWarning: false
    })),
    showWarningMessage: message_1 => setSnackbar(state_4 => ({
      ...state_4,
      isOpen: true,
      message: message_1,
      isError: false,
      isWarning: true
    })),
    hide: () => setSnackbar(_temp2)
  });
  const setSnackbar = t9;
  let t10;
  if ($[10] !== rightPanel || $[11] !== sharedDialog || $[12] !== snackbar) {
    t10 = {
      rightPanel,
      snackbar,
      sharedDialog
    };
    $[10] = rightPanel;
    $[11] = sharedDialog;
    $[12] = snackbar;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== children || $[15] !== t10) {
    t11 = <WorkspaceContext.Provider value={t10}>{children}</WorkspaceContext.Provider>;
    $[14] = children;
    $[15] = t10;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  return t11;
};
function _temp(stack_0) {
  return stack_0.slice(0, -1);
}
function _temp2(state_5) {
  return {
    ...state_5,
    isOpen: false,
    message: "",
    isError: false,
    isWarning: false
  };
}